import { typography } from '@dentalux/ui-library-core'
import { createUseStyles } from 'react-jss'
import { forPhoneOnly, forTabletPortraitUp } from 'src/config/mediaQueries'
import { COMPACT_SLOTS_STYLES, SlotsUseStylesProps } from '../Slots/Slots.styles'

const COMMON_WEEKDAY_STYLES = { display: 'flex', alignItems: 'center', flexDirection: 'column', userSelect: 'none' }

export default createUseStyles<string, SlotsUseStylesProps>(
  {
    root: {
      position: 'relative',
      display: 'flex',
      gap: 8,
      justifyContent: ({ variant }) => (variant === 'compact' ? 'center' : 'space-between'),

      [forTabletPortraitUp]: {
        gap: 16,
      },
    },
    multipleClinicsRoot: {},
    periodRange: {
      display: 'none',
      [forPhoneOnly]: {
        ...typography['Lato Emphasized 1'],
        display: 'block',
        textAlign: 'center',
        marginBottom: 16,
        padding: [3, 0],
      },
    },
    compactRoot: {
      justifyContent: 'center',
    },
    weekDay: ({ variant }) =>
      variant === 'compact'
        ? { ...COMPACT_SLOTS_STYLES, ...COMMON_WEEKDAY_STYLES }
        : { ...COMMON_WEEKDAY_STYLES, width: '100%' },
    weekDayName: {
      ...typography['Lato Body 1'],
      [forPhoneOnly]: {
        ...typography['Lato Body 2'],
      },
    },
    weekDayDate: {
      ...typography['Lato Emphasized 1'],
      [forPhoneOnly]: {
        ...typography['Lato Emphasized 2'],
      },
    },
  },
  { name: 'PeriodDays' }
)
